/* NixCart — shared behaviour: video play buttons, before/after, carousels. */
(function () {
  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-nc-play]').forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = 1;
      b.addEventListener('click', function () {
        var wrap = b.closest('[data-nc-video-wrap]'), v = wrap && wrap.querySelector('video');
        if (!v) return; v.controls = true; v.play(); wrap.classList.add('is-playing');
      });
    });
    scope.querySelectorAll('[data-nc-ba]').forEach(function (ba) {
      var r = ba.querySelector('input[type=range]');
      if (!r || r.dataset.bound) return; r.dataset.bound = 1;
      var set = function () { ba.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set); set();
    });
    scope.querySelectorAll('[data-nc-carousel]').forEach(function (c) {
      if (c.dataset.bound) return; c.dataset.bound = 1;
      var track = c.querySelector('[data-nc-track]'), dots = c.querySelectorAll('[data-nc-dot]');
      var step = function () { var f = track.children[0]; return f ? f.getBoundingClientRect().width + 14 : 300; };
      var p = c.querySelector('[data-nc-prev]'), n = c.querySelector('[data-nc-next]');
      p && p.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
      n && n.addEventListener('click', function () { track.scrollBy({ left: step() }); });
      track.addEventListener('scroll', function () {
        var max = track.scrollWidth - track.clientWidth, i = max > 0 ? Math.round(track.scrollLeft / max * (dots.length - 1)) : 0;
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
